import useSWR from 'swr';
import { fetcher } from '@commenda/utils';
import {
  IIndirectTaxRegistrationConditionsParams,
  IIndirectTaxRegistrationConditionsResponse,
} from './types';

export function useIndirectTaxRegistrationConditions(
  params: IIndirectTaxRegistrationConditionsParams | null
) {
  const key = params
    ? ['new-sales-tax/registrations-v2/content/registration-conditions', params]
    : null;

  const { data, error, isLoading, mutate } = useSWR<IIndirectTaxRegistrationConditionsResponse>(
    key,
    async ([url, body]) => {
      const response = await fetcher(url as string, { method: 'POST', body });
      if (!response.ok) throw new Error('Failed to fetch registration conditions');
      return response.json();
    }
  );

  return {
    data: data?.conditions ?? [],
    error,
    isLoading,
    mutate,
  };
}
